import React from 'react';
import PropTypes from 'prop-types';
import colors from '@strava/ui/colors';
import cx from '@strava/ui/clsx';
import I18n from 'utils/I18n';
import Button from '@strava/ui/Button';
import Popup from '@strava/ui/Popup';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import styles from './Thumbnail.scss';

function Thumbnail({
  file,
  index,
  highlightMediaId,
  setHighlightMedia,
  remove,
  loadingStates,
  uuid,
  mediaType
}) {
  return (
    <button
      className={cx(
        styles.thumbnailContainer,
        highlightMediaId === uuid ? styles.highlight : ''
      )}
      key={file.name}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
      onKeyDown={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <div className={styles.thumbnail}>
        {file && loadingStates[uuid] === 100 ? (
          <Popup
            contents={
              <ul className={styles.mediaPopup}>
                <li>
                  <Button
                    className={styles.mediaPopupButton}
                    onClick={(e) => {
                      setHighlightMedia(e, index);
                    }}
                  >
                    {I18n.t(`templates.activities.edit.photos.set_highlight`)}
                  </Button>
                </li>
                <li>
                  <Button
                    className={styles.mediaPopupButton}
                    onClick={(e) => {
                      remove(e, index);
                    }}
                  >
                    {I18n.t(`templates.activities.edit.photos.remove`)}
                  </Button>
                </li>
              </ul>
            }
            position="top"
          >
            <img
              key={file.name}
              src={file.preview}
              className={styles.thumbnailImage}
              // Revoke data uri after image is loaded
              alt={file.name}
            />
          </Popup>
        ) : (
          <div className={styles.spinnerContainer}>
            <CircularProgressbar
              value={loadingStates[uuid]}
              text=""
              className={styles.circleProgressBar}
              styles={buildStyles({
                pathColor: colors.O40_PUMPKIN
              })}
            />
          </div>
        )}
      </div>
      {/* Needed to pass values to update activity call */}
      <input type="hidden" name={`photos[${uuid}][rank]`} value={index} />
      <input
        type="hidden"
        name={`photos[${uuid}][media_type]`}
        value={mediaType}
      />
      <input type="hidden" name={`photos[${uuid}][caption]`} value="" />
    </button>
  );
}

Thumbnail.propTypes = {
  file: PropTypes.shape({
    preview: PropTypes.string,
    name: PropTypes.string
  }).isRequired,
  index: PropTypes.number.isRequired,
  highlightMediaId: PropTypes.string.isRequired,
  setHighlightMedia: PropTypes.func.isRequired,
  remove: PropTypes.func.isRequired,
  loadingStates: PropTypes.shape({}).isRequired,
  uuid: PropTypes.string.isRequired,
  mediaType: PropTypes.number.isRequired
};

export default Thumbnail;
